import ClientReportPage from './clientTabs/ClientReportPage'

export default function AdvisoryDashboards() {
  return <ClientReportPage typeId={2} reportDetailBasePath="/advisory-dashboards" />
}
